import { AlertCircle } from "lucide-react";

import { Button } from "components/ui/button";
import { Skeleton } from "components/ui/skeleton";
import type { TaxClosingTabs } from "@/services/tax-closing";

import { DataReadyView } from "./data-ready-view";
import type { TaxClosingTabKey } from "./tabs-config";
import type { ViewState } from "./view-state";

interface ViewStateRendererProps {
  state: ViewState;
  fiscalData: TaxClosingTabs | null;
  jobId: string | undefined;
  activeTab: TaxClosingTabKey;
  onTabChange: (value: string) => void;
  onBack: () => void;
}

/**
 * Dispatch de view por estado (sem cadeia de ternários nem else-if).
 */
export function ViewStateRenderer({
  state,
  fiscalData,
  jobId,
  activeTab,
  onTabChange,
  onBack,
}: ViewStateRendererProps) {
  const renderers: Record<ViewState, () => JSX.Element | null> = {
    loading: () => <LoadingView />,
    gone: () => <DataExpiredView onBack={onBack} />,
    ready: () =>
      fiscalData && jobId ? (
        <DataReadyView
          fiscalData={fiscalData}
          jobId={jobId}
          activeTab={activeTab}
          onTabChange={onTabChange}
        />
      ) : null,
    empty: () => null,
  };

  return renderers[state]();
}

function LoadingView() {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-24" />
        ))}
      </div>
      <Skeleton className="h-96" />
    </div>
  );
}

function DataExpiredView({ onBack }: { onBack: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16">
      <div className="h-16 w-16 rounded-full bg-orange-100 flex items-center justify-center">
        <AlertCircle className="h-8 w-8 text-orange-600" />
      </div>
      <p className="text-lg font-semibold">Dados expirados</p>
      <p className="text-sm text-muted-foreground max-w-md text-center">
        O cache desta extração expirou. Execute uma nova extração para
        visualizar os resultados.
      </p>
      <Button onClick={onBack}>Voltar para Extrações</Button>
    </div>
  );
}
